import { BUTTON_SIZE, BUTTON_TYPE, COLORS, DSButton } from '@repo/design-system/index'
import { QIcon_check_filled, QIcon_close_default } from '@repo/icons/index'
import dynamic from 'next/dynamic'
import * as animationData from '../../../../animations/fire.json'
import { n_ai_tutor, n_common } from '../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../modules/i18n/useTranslation'
import { ReactComponent as FireInactive } from '../../../common/icons/fire_active.svg'
import { AITutorStreakCard } from '../AITutorCard'

const Lottie = dynamic(() => import('react-lottie'), { ssr: false })

const streakDays = [
  n_ai_tutor.study_activity.day7,
  n_ai_tutor.study_activity.day1,
  n_ai_tutor.study_activity.day2,
  n_ai_tutor.study_activity.day3,
  n_ai_tutor.study_activity.day4,
  n_ai_tutor.study_activity.day5,
  n_ai_tutor.study_activity.day6,
]

const DoneStreakWeekly = ({ dateArray, count }) => {
  const { t } = useTranslation()
  return (
    <div className="bg-white rounded-xl border border-gray-100 py-[20px] px-[16px] flex flex-row gap-[14px] items-center justify-center self-stretch">
      {dateArray.map((day, index) => (
        <div key={day} className="flex flex-col gap-[8px] items-center justify-start w-[28px]">
          <div
            className={`text-center text-[16px] leading-[24px] ${
              index === count - 1 ? 'text-red-400 font-bold' : 'text-gray-400 font-medium'
            }`}
          >
            {t(day)}
          </div>
          <div className="w-[28px] h-[28px] flex items-center justify-center">
            {index === count - 1 ? (
              <div className="w-[33px] h-[33px] relative top-[-1px]">
                <FireInactive width={33} height={33} />
              </div>
            ) : index < count - 1 ? (
              <div className="bg-red-400 rounded-full w-[24px] h-[24px]">
                <QIcon_check_filled color={COLORS.RED400} className="w-[24px] h-[24px]" />
              </div>
            ) : (
              <div className="bg-gray-200 rounded-full w-[24px] h-[24px]"></div>
            )}
          </div>
        </div>
      ))}
    </div>
  )
}

const DoneStreak = ({ streak, close, nextLesson }) => {
  const { t } = useTranslation()
  const count = streak?.streak?.streak || 0
  const endDate = new Date(streak?.streak?.last_date)
  const beginDate = new Date(endDate)
  beginDate.setDate(endDate.getDate() - Math.min(count, 7) + 1)

  const dateArray = [...streakDays.slice(beginDate.getDay()), ...streakDays.slice(0, beginDate.getDay())]
  const defaultOptions = {
    loop: false,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  }

  return (
    <div className="my-[14px] px-[20px] flex flex-col gap-[48px] items-center justify-start flex-1">
      <div className="flex w-full flex-col items-end justify-center self-stretch">
        <QIcon_close_default onClick={close} width={24} height={24} />
      </div>
      <div className="flex flex-col gap-[16px] items-center justify-start self-stretch">
        <div className="w-full relative overflow-hidden">
          <Lottie options={defaultOptions} height={120} width={120} isClickToPauseDisabled={true} />
        </div>
        <div className="flex flex-col gap-[8px] items-center justify-start self-stretch">
          <div className="bg-red-50 rounded px-[10px] py-[4px] flex flex-row gap-[4px] items-start justify-start">
            <div className="text-red-400 text-left text-[14px] leading-[20px] font-bold">
              {t(n_ai_tutor.acheivement.streak)}
            </div>
          </div>
          <div className="flex flex-col gap-[4px] items-start justify-start self-stretch">
            <div className="text-black text-center text-[48px] leading-[56px] font-bold self-stretch flex items-end justify-center">
              {t(n_ai_tutor.acheivement.day(streak?.streak?.streak || 0))}
            </div>
            <div className="text-gray-500 text-center text-[18px] leading-[26px] font-medium self-stretch h-[26px] flex items-end justify-center">
              {t(n_ai_tutor.study_activity.detail3)}
            </div>
          </div>
        </div>
      </div>
      {count < 7 ? <DoneStreakWeekly dateArray={dateArray} count={count} /> : <AITutorStreakCard streak={count} />}
      <div className="w-full bg-white py-[12px] mb-[20px] sticky bottom-[20px] left-[0px] mt-[auto]">
        <DSButton size={BUTTON_SIZE.LG} type={BUTTON_TYPE.SOLID} onClick={nextLesson}>
          <DSButton.Label>{t(n_common.btn_continue)}</DSButton.Label>
        </DSButton>
      </div>
    </div>
  )
}

export default DoneStreak
